import { FormControl, MenuItem, Select } from "@mui/material";
import classNames from "classnames";
import { FC } from "react";
import { Option } from "../../libs/types";
import styles from "./dropdown.module.scss";


const Dropdown: FC<DropdownProps> = (props: DropdownProps) => {
    const { label, options, value, onChange, required, labelStyle, selectStyle } = props;


    return (
        <div className={styles.dropdown_group}>
            {label && label !== "" && <div className={classNames(`${styles.label}`, labelStyle)}><div>{label}{required && <span>*</span>}</div></div>}
            <FormControl variant="outlined" fullWidth className={selectStyle}>
                <Select value={value} onChange={(e: any) => onChange(e.target.value)} >
                    {options && options.map((item, index) => <MenuItem key={index} value={item.value}>{item.name}</MenuItem>)}
                </Select>
            </FormControl> 
        </div>
    )
}

export interface DropdownProps {
    label?: string;
    options: Option[];
    value?: string | number;
    onChange: (val: any) => void;
    required?: boolean;
    defaultVal?: string;
    labelStyle?: string;
    selectStyle?: string;
}

export default Dropdown;